"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preferentialCurrencies = void 0;
exports.preferentialCurrencies = ['USD', 'EUR', 'USDT', 'GBP'];
//# sourceMappingURL=preferential-currencies.js.map